import { type ReactElement } from 'react';
import { STYLES } from '../../styles';
import { processTextWithBold } from '../../utils';

const BulletsList = ({ bullets }: { bullets: string[] }): ReactElement => (
  <ul className={STYLES.BULLETS_LIST}>
    {bullets.map((bullet, bulletIndex) => (
      <li key={bulletIndex} className={STYLES.BULLET_ITEM}>
        {processTextWithBold(bullet)}
      </li>
    ))}
  </ul>
);

export default BulletsList;
